import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import { Button } from 'antd';

const ButtonLoader = ({
  loading = false,
  action = () => false,
  text = 'default message',
  position = 'right',
  type = 'primary',
  style = {},
}) => {
  let classN;
  switch (type) {
    case 'primary':
      classN = 'btn-primary';
      break;
    default:
      classN = 'btn-danger';
  }

  return (
    <div style={{ width: '100%' }}>
      <Button
        type='primary'
        style={{ float: position, ...style }}
        className={`btn ${classN}`}
        onClick={action}
        disabled={loading}
        htmlType='submit'
      >
        {loading && (
          <>
            <span style={{ display: 'inline-block', textAlign: 'center' }}>
              {text}
            </span>
            <Loader
              style={{ display: 'inline-block', marginLeft: '5px' }}
              type='Oval'
              color='#00BFFF'
              height={10}
              width={10}
            />
          </>
        )}
        {!loading && <span>{text}</span>}
      </Button>
    </div>
  );
};

ButtonLoader.propTypes = {
  loading: PropTypes.bool,
  action: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  position: PropTypes.oneOf(['left', 'right', 'none']),
  type: PropTypes.oneOf(['default', 'primary']),
};

export default ButtonLoader;
